var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 321",
    d: "M4 4C4 2.89543 4.89543 2 6 2H9.42105C11.0779 2 12.4211 3.34315 12.4211 5V7.5C12.4211 8.88071 13.5403 10 14.9211 10H17C18.6569 10 20 11.3431 20 13V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z",
    stroke: "#616161",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 321_2",
    d: "M4 4C4 2.89543 4.89543 2 6 2H9.23393C11.5937 2 13.8332 3.04186 15.3532 4.84691L18.1193 8.13163C19.3339 9.57399 20 11.399 20 13.2847V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z",
    stroke: "#616161",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.2491aafcbcb57e1b46ef0742d26edf6b.svg";
export { ForwardRef as ReactComponent };